import { useContext, useEffect, useState } from "react";
import { RightsHoldersNamesViewModel } from "../../../generated/data-contracts";
import { RightsHolderType } from "../../../models";
import { IAxiosError, api } from "../../../utils";
import { AvisForm } from "../../shared/components";
import { AvisDescriptiveText } from "../../shared/components/form";
import { AvisContext } from "../../shared/context/AvisContext";
import { NamesGrid } from "./NamesGrid";
import { SubmitName } from "./submitName/SubmitName";

export function NamesPage() {
  const { res, ctxRightsHolder } = useContext(AvisContext);

  const [initGridData, setInitGridData] = useState<
    RightsHoldersNamesViewModel[] | undefined
  >();
  const [isGridLoading, setIsGridLoading] = useState<boolean>(true);
  const [error, setError] = useState<IAxiosError>();

  const getGridData = () => {
    if (!ctxRightsHolder?.rightsHolderId) return;
    if (!isGridLoading) setIsGridLoading(true);

    api
      .rightsHoldersGetRightsHolderNamesByRightsHolderId(
        ctxRightsHolder.rightsHolderId,
      )
      .then((res) => setInitGridData(res.data))
      .catch(setError)
      .finally(() => {
        setIsGridLoading(false);
      });
  };
  useEffect(() => {
    getGridData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <AvisForm title={res("authors_NamesPage_Title")}>
      <AvisDescriptiveText textKey="portal_RH_RightsHolderNames_1" />

      {ctxRightsHolder?.rightsHolderTypeCode !== RightsHolderType.Publisher && (
        <SubmitName
          rhNames={initGridData}
          onSubmit={getGridData}
          loading={isGridLoading}
        />
      )}

      <NamesGrid
        error={error}
        initData={initGridData}
        loading={isGridLoading}
      />
    </AvisForm>
  );
}
